import React, { useRef, useEffect, useState, useContext } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Heading } from '@fluid/typography-ui';
import { Button } from '@fluid/buttons';
import { getLocaleText } from '../utils/LoginUtils';
import { isDark } from '../utils/cssUtil';
import { PRIMARY_BTN_BG_COLOR_PROP } from '../Constants';
import LoginContext from '../context/LoginContext';

const baseCls = 'dbk-login-msg';
const LoginMessage = (props) => {
    const { loginConfig, locale, contextCls, theme, isInteractive } = props;
    const { loginMessageImageGroup, loginMessageGroup } = loginConfig ?? {};
    const { loginMessageImageUrl } = loginMessageImageGroup ?? {};
    const { loginMessageTitle, loginMessage } = loginMessageGroup ?? {};
    // const classNames = [];
    const [shouldHideMessage, setShouldHideMessage] = useState(false);

    const { context, setContext } = useContext(LoginContext);
    const messageRef = useRef();
    useEffect(() => {
        if (messageRef.current && !isInteractive) {
            const anchors = [...messageRef.current.getElementsByTagName('a')];
            anchors.forEach((anchorParam) => {
                const anchor = anchorParam;
                anchor.tabIndex = -1;
            });
        }
    }, [messageRef.current]);

    // if (contextCls) {
    //     classNames.push(contextCls);
    // }

    const loginMessageTitleIsString =
        Object.prototype.toString.call(loginMessageTitle) === '[object String]';
    const title = loginMessageTitleIsString
        ? loginMessageTitle
        : getLocaleText(loginMessageTitle, locale);
    const loginMessageIsString =
        Object.prototype.toString.call(loginMessage) === '[object String]';
    const message = loginMessageIsString
        ? loginMessage
        : getLocaleText(loginMessage, locale);
    const hasText = message || title;

    useEffect(() => {
        const messageContext = {
            hasText,
            hasImage: !!loginMessageImageUrl,
        };
        setContext({ ...context, ...messageContext });
    }, [title, message]);

    if (!loginMessageImageUrl && !title && !message) {
        return false;
    }

    const style = {
        ...(!!loginMessageImageUrl && {
            backgroundImage: `url('${loginMessageImageUrl}')`,
        }),
    };

    // if (!isInteractive) {
    //     classNames.push('read-only');
    // }

    // if (hasText) {
    //     classNames.push('has-text');
    // }

    // if (loginMessageImageUrl) {
    //     style.backgroundImage = `url(${loginMessageImageUrl})`;
    //     // classNames.push('has-image');
    // }
    // else {
    //     const isDarkBackground = isDark(theme, PRIMARY_BTN_BG_COLOR_PROP);
    //     classNames.push(isDarkBackground ? 'is-dark-bg' : 'is-light-bg');
    // }
    const shouldRenderToggleBtn =
        isInteractive && hasText && !!loginMessageImageUrl;

    const isDarkBackground = isDark(theme, PRIMARY_BTN_BG_COLOR_PROP);
    const modCls = {
        'read-only': !isInteractive,
        'has-text': hasText,
        'has-image': !!loginMessageImageUrl,
        'is-dark-bg': !loginMessageImageUrl && isDarkBackground,
        'is-light-bg': !loginMessageImageUrl && !isDarkBackground,
        [`${baseCls}--should-collapse-msg`]: shouldHideMessage,
    };

    const handleMessageToggleClick = () => {
        setShouldHideMessage(!shouldHideMessage);
    };

    return (
        <div className={cx(baseCls, modCls, contextCls)} style={style}>
            {shouldRenderToggleBtn && (
                <Button
                    contextCls={`${baseCls}__message-toggle-btn`}
                    iconCls={`${baseCls}__message-toggle-btn-icon`}
                    aria-label="Toggle Message Visibility"
                    onClick={handleMessageToggleClick}
                />
            )}
            {hasText && !shouldHideMessage && (
                <div className={`${baseCls}--inner`}>
                    <div className={`${baseCls}--inner-wrapper`}>
                        {title && <Heading>{title}</Heading>}
                        {message && (
                            <p
                                ref={messageRef}
                                dangerouslySetInnerHTML={{ __html: message }}
                            />
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};

LoginMessage.defaultProps = {};

LoginMessage.propTypes = {
    loginConfig: PropTypes.object.isRequired,
    locale: PropTypes.string.isRequired,
    contextCls: PropTypes.string,
    theme: PropTypes.object,
    isInteractive: PropTypes.bool,
};

export default LoginMessage;
